/* eslint-disable jsdoc/check-types -- Introduced in TP-9489. */
/* eslint-disable jsdoc/tag-lines -- Introduced in TP-9489. */

import * as api from 'api';

import Tools from '../Tools/Tools';

const apiUrl = '/app/api/webs/ssp-served';
let loadedPages = 0;
let everythingLoaded = false;
const webList = document.querySelector('.js-webList');

/**
 * Zneaktivní tlačítko na načítání webů
 */
const stopButton = () => {
	document.querySelector('.js-ga-loadWebs').disabled = true;
	everythingLoaded = true;
};

const _createGdprLinkWithIcon = (gdprUrl) => {
	const link = Tools.createElement('a', {
		href: gdprUrl,
		target: '_blank',
	});

	const icon = Tools.createElement('img', {
		src: '/app/static/img/gdpr_ic2.svg',
		class: 'gdpr-icon',
	});

	link.appendChild(icon);

	return link;
};

/**
 * Přidá web na stránku a započítá ho
 * @param {Object} web Objekt webu obsahující url a jméno
 */
const addWeb = (web) => {
	const listItem = Tools.createElement('li');

	const link = Tools.createElement('a', {
		innerText: web.host,
		href: web.url,
		target: '_blank',
	});

	listItem.appendChild(link);

	/* eslint-disable camelcase */
	const { gdpr_urls } = web;

	// https://youtrack.seznam.net/issue/SSP-6627
	// Pokud alespoň jeden z webů má vyplněno url_gdpr, tak ukázat ikonu/ikony s odkazem tolikrát kolikrát je to vyplněno (nejčastěji to bude pouze jednou).
	if (gdpr_urls) {
		gdpr_urls.forEach((gdpr_url) => {
			listItem.appendChild(_createGdprLinkWithIcon(gdpr_url));
		});
	}
	// https://youtrack.seznam.net/issue/SSP-6627
	// Když ani jeden z webů nemá naše CMP - zobrazit ikonu s odkazem na seznamácké podmínky https://partner.seznam.cz/app/ochrana-soukromi.
	else {
		listItem.appendChild(
			_createGdprLinkWithIcon('https://partner.seznam.cz/app/ochrana-soukromi'),
		);
	}
	/* eslint-enable camelcase */

	webList.appendChild(listItem);
};

/**
 * Načte dávku webů ze serveru
 */
const loadWebs = () => {
	const offset = loadedPages;
	const getUrl = apiUrl + '?page=' + offset;

	api
		.GET(getUrl, true, false)
		.then(({ data }) => {
			data.webs.forEach((web) => {
				addWeb(web);
			});

			loadedPages++;

			if (loadedPages >= data.pages) {
				stopButton();
			}
		})
		.catch(console.error);
};

/**
 * Slouží k načítání zapojených webů
 */
const initInvolvedWebs = () => {
	const loadButton = document.querySelector('.js-ga-loadWebs');

	if (!loadButton) {
		// na strance neni tlacitko, nic se nacitat nebude
		return;
	}

	loadButton.addEventListener('click', () => {
		if (!everythingLoaded) {
			loadWebs();
		}
	});

	// první dávku načíst hned
	loadWebs();
};

export default initInvolvedWebs;
